import React from 'react';
import { Box, Card, CardContent, Grid, Typography } from '@mui/material';

const PlanCard = ({ name, price, features }) => (
  <Card>
    <CardContent>
      <Typography variant="h6">{name}</Typography>
      <Typography variant="h4" sx={{ my: 1 }}>{price}</Typography>
      {features?.map((f) => (
        <Typography key={f} variant="body2" color="text.secondary">• {f}</Typography>
      ))}
    </CardContent>
  </Card>
);

const Subscriptions = () => {
  return (
    <Box>
      <Typography variant="h5" gutterBottom>Subscription & Billing</Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}><PlanCard name="Free" price="$0" features={["Basic cycle tracking", "Mood logging", "Journal"]} /></Grid>
        <Grid item xs={12} md={4}><PlanCard name="Premium" price="$4.99/mo" features={["AI recommendations", "Sharing", "Calendar sync"]} /></Grid>
        <Grid item xs={12} md={4}>
          <Card>
            <CardContent>
              <Typography variant="subtitle1">Payment Monitoring</Typography>
              <Typography variant="body2" color="text.secondary">Stripe/PayPal integration placeholder.</Typography>
              <Box sx={{ height: 160, bgcolor: 'action.hover', borderRadius: 1, mt: 2 }} />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Subscriptions;
